import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import iconUpgrade from '@src/assets/images/icon-paid-package.png';
import { useSelector } from 'react-redux';
import { getDefaultValueCustomResource } from '@src/services/package';
import usePaywallTracking from '@src/hooks/usePaywallTracking';
import { MOE_PAYWALL_CTA, MOE_PAYWALL_TYPE } from '@src/constants/moengage';

const OutOfCreditsCustom = ({ open, onClose }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { usingPackage } = useSelector((state) => state.user);
  const { code } = usingPackage;
  const {
    defaultCredits = 0,
    defaultDevices = 0,
    defaultVoiceClonings = 0,
  } = getDefaultValueCustomResource(usingPackage?.customResource) || {};

  const { trackCta } = usePaywallTracking({
    paywallType: MOE_PAYWALL_TYPE.OUT_OF_CREDITS,
  });

  const handleBuyMore = () => {
    trackCta(MOE_PAYWALL_CTA.TOPUP, { targetPackageCode: code });
    const url = `${ROUTES.PAYMENT}?package=${code}&credits=${defaultCredits}&devices=${defaultDevices}&voiceClonings=${defaultVoiceClonings}`;
    history.push(url);
  };

  const renderBuyMoreButton = () => (
    <Button variant="contained" onClick={handleBuyMore}>
      {t('buyMoreChar')}
    </Button>
  );

  return (
    <NotificationDialogV4
      image={iconUpgrade}
      title={t('outOfCredits')}
      description={t('descriptionOutOfCreditsCustom')}
      actionComponent={renderBuyMoreButton()}
      open={open}
      onClose={onClose}
    />
  );
};

export default OutOfCreditsCustom;
